import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@mui/styles';
import { withRouter } from "common/utils/router.util";
import { withStyles } from '@mui/styles';
import { MailProDialog } from 'views/Pma/MailPro/components/MailProDialog/MailProDialog';
import { MailProDialogHeader } from 'views/Pma/MailPro/components/MailProDialog/MailProDialogHeader';
import { MailProDialogBody } from 'views/Pma/MailPro/components/MailProDialog/MailProDialogBody';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        fontFamily: "objektiv-mk2 !important",
    },
    backDropBackgroundDark: {
        background: "rgba(0, 0, 0, 0.8)",
    },
    objectivMk2: {
        fontFamily: "objektiv-mk2 !important",
    },
    connfirmationDialogPaper: {
        minWidth: '600px'
    },
    connfirmationDialogHeader: {
        fontSize: '15px',
        fontFamily: "objektiv-mk2",
        lineHeight: "18px",
        letterSpacing: "0.01em",
        fontWeight: 500,
        color: 'white',
        textAlign: 'center'
    },
    margin: {
        margin: theme.spacing(1),
    },
    footerButtons: {
        position: 'relative',
        display: 'flex',
    },
    portletFooter: {
        display: 'inline-block',
        paddingLeft: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        width: '100%'
    },
    footerButtonsCenter: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    footerButtonsLeftRight: {
        flex: 1,
    },
    customPrimaryButton: {
        backgroundColor: theme.palette.primary.currentMailProColor,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.currentMailProColor,
            opacity: 0.9
        }
    }
}));

export default function CommonConfirmationDialogV2({
    title,
    subtitle,
    methodToCallOnConfirmation,
    methodToCallOnCancel,
    confirmationButtonText,
    cancelButtonText,
    className,
    children,
    isDisabled = false,
    headerClass = {},
    bodyClassName,
    bodyStyle
}) {

    const [open, setOpen] = React.useState(false);

    /**classes */
    const classes = useStyles();

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirmationClick = () => {
        /**call the close method first */
        handleClose();
        methodToCallOnConfirmation && methodToCallOnConfirmation();
    };

    const handleCancelClick = () => {
        /**call the close method first */
        handleClose();
        methodToCallOnCancel && methodToCallOnCancel();
    };

    return (
        <div>
            <div onClick={() => !isDisabled && setOpen(true)} className={classes.objectivMk2}>{children}</div>
            <MailProDialog
                open={open}
                classes={{
                    paper: classes.connfirmationDialogPaper
                }}
                className={className || ''}
                BackdropProps={{
                    classes: {
                        root: classes.backDropBackgroundDark,//backDropBackgroundLightBlue,
                    },
                }}
                disableEnforceFocus>
                <MailProDialogHeader>
                    <div className={classNames(classes.connfirmationDialogHeader, headerClass)}>{title}</div>
                </MailProDialogHeader>
                <MailProDialogBody className={bodyClassName} style={bodyStyle}>
                    {subtitle}
                </MailProDialogBody>
                <DialogActions>
                    <div className={classes.portletFooter}>
                        <div className={classes.footerButtons}>
                            <div className={classes.footerButtonsLeftRight}>
                                <Button
                                    variant="outlined"
                                    onClick={handleCancelClick}
                                    color="inherit"
                                    className={classes.objectivMk2}
                                    size='small'
                                    sx={{
                                        padding: '3px 10px',
                                        minHeight: 30,
                                        fontSize: '0.8125rem',
                                        lineHeight: 1.2,
                                        fontWeight: 500,
                                        color: '#12161b',
                                        borderColor: '#c2c2c2',
                                        backgroundColor: '#fbfbf5',
                                    }}
                                >
                                    {cancelButtonText ? cancelButtonText : 'Cancel'}
                                </Button>
                            </div>
                            <div className={classes.footerButtonsCenter}>
                                <Button
                                    variant="contained"
                                    onClick={handleConfirmationClick}//in handle close we are passing confirmation method
                                    color="primary"
                                    className={`${classes.objectivMk2} ${classes.customPrimaryButton}`}
                                    size='small'
                                    sx={{ padding: '4px 12px', minHeight: 32, fontSize: '0.8125rem', lineHeight: 1.2, fontWeight: 600 }}
                                >
                                    {confirmationButtonText ? confirmationButtonText : 'Yes, Proceed'}
                                </Button>
                            </div>
                            <div className={classes.footerButtonsLeftRight}></div>
                        </div>
                    </div>
                </DialogActions>
            </MailProDialog>
        </div>
    );
}
